/**
 * FileRow — single downloadable document inside an expanded FolderItem.
 * Stays interactive (no pointer-events disabled) even when error is present.
 */
const FileIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" style={{ flexShrink: 0 }}>
    <path d="M9 1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V6L9 1z" fill="#fce4e4" stroke="#e53935" strokeWidth="0.8" />
    <path d="M9 1v5h4" fill="#fce4e4" stroke="#e53935" strokeWidth="0.8" />
    <text x="4.5" y="13" fontSize="4.5" fontWeight="bold" fill="#e53935" fontFamily="Arial, sans-serif">PDF</text>
  </svg>
);

const FileRow = ({ doc, error, onActivate }) => (
  <div className="ddv-file-row">
    <button
      type="button"
      className="ddv-file-btn"
      onClick={onActivate}
    >
      <FileIcon />
      <span className="ddv-file-name">{doc.documentName}</span>
    </button>
    {error && (
      <p className="ddv-file-error" role="alert">{error}</p>
    )}
  </div>
);

export default FileRow;
